import { Group, GroupOfUser } from '@era/security-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectUserIdFromParent(group: GroupOfUser) {
  return `${group.userId}-${group.id}`;
}
export const adapter: EntityAdapter<Group> = createEntityAdapter<GroupOfUser>({
  selectId: selectUserIdFromParent,
});

export type UserGroupState = EntityState<GroupOfUser>;

export const initialstate: UserGroupState = adapter.getInitialState();
